document.addEventListener("DOMContentLoaded", function () {
  document.documentElement.classList.add('custom-js-ready');
  document.querySelectorAll('a[href*="/cart/add"]').forEach(function(link){
    link.style.pointerEvents = '';
  });
  const reviewSummary = document.querySelector('.review-section');
  const reviewSummary2 = document.querySelector('.review-section.mobile.mobile-reviews');
  const reviewWidget = document.querySelector('#judgeme_product_reviews');

  $(document).on("click",".mix_match_open_drawer", function () {
    $("body").addClass("mix_match_open");
  });

  $(document).on("click",".close_mix_match", function () {
    $("body").removeClass("mix_match_open");
  });
  
  if (reviewSummary && reviewWidget) {
    reviewSummary.addEventListener('click', function(e) {
      e.preventDefault();
      reviewWidget.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
      });
    });
  }

  if (reviewSummary2 && reviewWidget) {
    reviewSummary2.addEventListener('click', function(e) {
      e.preventDefault();
      reviewWidget.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
      });
    });
  }

  $(document).on("click", "#menu-drawer .disclosure__button.localization-form__select", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const isExpanded = $btn.attr("aria-expanded") === "true";
    $btn.attr("aria-expanded", !isExpanded);
    const $form = $btn.closest(".localization-form");
    const $countryList = $form.find("#HeaderDrawerCountryList");
    const $langList = $form.find("#HeaderDrawerLanguageList");

    const $list = $countryList.length ? $countryList : $langList;

    if ($list.attr("hidden")) {
      $list.removeAttr("hidden");
      $("body").addClass("country-list-open");
    } else {
      $list.attr("hidden", true);
      $("body").removeClass("country-list-open");
    }
  });

  $(document).on("click", "#HeaderLanguageList a, #HeaderCountryList a, #HeaderDrawerCountryList a, #HeaderDrawerLanguageList a", function (e) {
    e.preventDefault();
    const $link = $(this);
    const selectedValue = $link.data("value");
    const isLanguage = $link.closest("#HeaderLanguageList, #HeaderDrawerLanguageList").length;
    const inputName = isLanguage ? "locale_code" : "country_code";
    const $input = $(`input[type="hidden"][name="${inputName}"]`);
    $input.val(selectedValue);
    $input.closest("form").submit();
  });

  var timerSection = document.querySelector(".alcami-timer-sec");
  if (timerSection) {
    document.body.classList.remove("no-timer");
    document.body.classList.add("has-timer");
    var timerData = timerSection.querySelector(".alcami-timer-m");
    if (timerData) {
      var timerValue = parseInt(timerData.dataset.timerValue) || 15;
      var timerUnit = timerData.dataset.timerUnit || "minutes";
      var durationInSeconds;

      switch (timerUnit) {
        case "days":
          durationInSeconds = timerValue * 24 * 60 * 60;
          break;
        case "hours":
          durationInSeconds = timerValue * 60 * 60;
          break;
        case "minutes":
          durationInSeconds = timerValue * 60;
          break;
        case "seconds":
        default:
          durationInSeconds = timerValue;
      }

      var TIMER_END_KEY = "alcami_timer_end";
      var TIMER_HIDE_UNTIL_KEY = "alcami_timer_hide_until";

      var now = Date.now();
      var hideUntil = localStorage.getItem(TIMER_HIDE_UNTIL_KEY);

      if (hideUntil && now < parseInt(hideUntil)) {
        timerSection.remove();
          document.body.classList.add("no-timer");
          document.body.classList.remove("has-timer");
      } else {
        var savedEndTime = localStorage.getItem(TIMER_END_KEY);
        var endTime;
        if (savedEndTime) {
          endTime = parseInt(savedEndTime);
        } else {
          endTime = now + (durationInSeconds * 1000);
          localStorage.setItem(TIMER_END_KEY, endTime);
        }

        var daysEl = timerSection.querySelector("#alcami-days");
        var hoursEl = timerSection.querySelector("#alcami-hours");
        var minutesEl = timerSection.querySelector("#alcami-minutes");
        var secondsEl = timerSection.querySelector("#alcami-seconds");

        var timer = setInterval(function () {
          var remaining = Math.floor((endTime - Date.now()) / 1000);

          if (remaining <= 0) {
            clearInterval(timer);
            var fourHoursLater = Date.now() + (10 * 60 * 1000);
            localStorage.setItem(TIMER_HIDE_UNTIL_KEY, fourHoursLater);
            localStorage.removeItem(TIMER_END_KEY);
            timerSection.remove();
              document.body.classList.add("no-timer");
              document.body.classList.remove("has-timer");
            return;
          }

          var days = Math.floor(remaining / (60 * 60 * 24));
          var hours = Math.floor((remaining % (60 * 60 * 24)) / (60 * 60));
          var minutes = Math.floor((remaining % (60 * 60)) / 60);
          var seconds = remaining % 60;

          if (daysEl) daysEl.textContent = String(days).padStart(2, "0");
          if (hoursEl) hoursEl.textContent = String(hours).padStart(2, "0");
          if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
          if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");

        }, 1000);
      }
    }

  } else {
    document.body.classList.remove("no-timer");
    document.body.classList.add("has-timer");
  }

  $(".alcami-featured-list.alcami-pdp-featured-list").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    variableWidth: true,
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: false
  });

  $('.alcami-featured-list.alcami-featured-slider').slick({
    mobileFirst: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    speed: 900,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  });

  $(".alcami-ingredients-sec .alcami-ingredients-list-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    nextArrow: '<div class="next_arrow_slick alcami-ingredient-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-ingredient-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2500
        }
      }
    ]
  });

  var $slider = jQuery('.alcami-slideshow-list');

  $slider.on('init', function () {
    $('.title-carousel').each(function () {
      if (!$(this).hasClass('slick-initialized')) {
        $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
          speed: 1500,
          infinite: true,
          cssEase: 'cubic-bezier(.4,0,.2,1)',
          draggable: false,
          swipe: false,
          touchMove: false
        });
      }
    });
  });

  $slider.slick({
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-slideshow-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-slideshow-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    dots: false,
    infinite: true,
    slidesToShow: 1,
    speed: 700,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          adaptiveHeight: true, 
          arrows: false
        }
      }
    ]
  });

  $('.alcami-slideshow-list').on('init afterChange', function (event, slick, currentSlide) {
    var index = currentSlide || 0;
    var $slider = $(this);
    var isMobile = window.innerWidth < 750;
    $('.title-carousel').slick('setPosition');

    $slider.find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });

    var $currentSlide = $slider.find('.slick-slide[data-slick-index="' + index + '"]');
    var $video = $currentSlide.find('video');

    if ($video.length) {
      $video.prop('muted', true);
      if (!isMobile) {
        $video.get(0).play();
      }
    }
  });

  var isMouseInsideSlider = false;
  var currentPlayingVideo = null;

  $(".us-vs-them-btn a").on("click", function (ev) {
    ev.preventDefault();
    const pdpUrl = $(this).attr("data-pdp");
    if (!pdpUrl) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      return;
    }

    const selectors = [
      ".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver",
      ".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver"
    ];

    selectors.forEach((sectionSelector) => {
      const section = document.querySelector(sectionSelector);
      if (!section) return;

      const teaItem = section.querySelector(`[data-pdp-url="${pdpUrl}"]`);
      if (!teaItem) return;
      section.querySelectorAll(".new-layout-tea-item.active-tea-item").forEach((item) => {
        item.classList.remove("active-tea-item");
      });

      teaItem.click();
      const targetBox = section.querySelector(".new_layout_box");

      if (targetBox) {
        targetBox.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

      const plusBtn = teaItem.querySelector(".plus-tea");
      if (plusBtn) {
        plusBtn.click();
      }
    });
  });

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
      $('.store-header').addClass('sticky');
    } else {
      $('.store-header').removeClass('sticky');
    }
  });

  function initMobileSlickSliders() {
    const isMobile = window.innerWidth < 749;
    const sliders = [
      {
        selector: '.supplements-lp24-list',
        settings: {
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          infinite: false
        }
      },
      {
        selector: '.dcx-shilajit__grid',
        settings: {
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          infinite: true
        }
      },
      {
        selector: '.dcx-colostrum__grid',
        settings: {
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          infinite: true
        }
      }
    ];
    sliders.forEach(function(sliderData){
      const slider = $(sliderData.selector);
      if (!slider.length) return;
      if (isMobile) {
        if (!slider.hasClass('slick-initialized')) {
          requestAnimationFrame(function(){
            slider.slick(sliderData.settings);
          });
        }
      } else {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
      }
    });
  }

  initMobileSlickSliders();

  $('.main-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.thumbnail-gallery',
    focusOnSelect: true,
    infinite: false
  });

  $('.main-gallery').slick('setPosition');

  $('.thumbnail-gallery').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.main-gallery-mix').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    asNavFor: '.thumbnail-gallery-mix',
    focusOnSelect: true,
    infinite: false
  });

  $('.main-gallery-mix').slick('setPosition');

  $('.thumbnail-gallery-mix').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.main-gallery-mix',
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.thumbnail-gallery').on('click', '.tumb_img img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.main-gallery').slick('slickGoTo', index);
  });

  $('.thumbnail-gallery-mix').on('click', '.tumb_img img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.main-gallery-mix').slick('slickGoTo', index);
  });

  $('.kit-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.kit-thumbnail-gallery',
    focusOnSelect: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true
        }
      }
    ]
  });

  $('.kit-thumbnail-gallery').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.kit-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.kit-thumbnail-gallery').on('click', 'img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.kit-gallery').slick('slickGoTo', index);
  });

  $('.alcami-ritual-products-list').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    centerMode: true,
    centerPadding: '30px',
    responsive: [
      {
        breakpoint: 749,
        settings: "unslick"
      }
    ]
  });

  $('.alcami-leaders-list').slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });

    $(".alcami-before-after-list").slick({
      dots: false,
      arrows: true,
      nextArrow: '<div class="next_arrow_slick alcami-before-after-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
      prevArrow: '<div class="prev_arrow_slick alcami-before-after-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
      infinite: true,
      speed: 300,
      draggable: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    });

  $(".alcami-testimonials-sec .alcami-testimonials-list").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    variableWidth: true,
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    draggable: false,
    swipe: false,
    touchMove: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          variableWidth: false
        }
      }
    ]
  });

  $('.unique-perks-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  function updateHeroPrice() {
    const $checked = $('.hero_input_list input[type="radio"]:checked');
    if (!$checked.length) return;

    const checkedId = $checked.attr('id');
    const servings = checkedId.match(/\d+/)?.[0];

    $('.hero_flavor_container.subs_hero_flavor_container').removeClass('active');
    $('.try-once-btn').removeClass('is-active').hide();
    $('.hero_prices_span').hide();
    $(".single_cup_price").hide();
    $('.single_hero_btn').removeClass('is_active_hero').hide();

    if (!servings) return;

    const flavorIndex = (parseInt(servings, 10) / 30) - 1;
    $('.hero_flavor_container.subs_hero_flavor_container').eq(flavorIndex).addClass('active');
    $(`.try-once-btn[data-servings="${servings}"]`).show().addClass('is-active');

    const $activeBtn = $(`.single_hero_btn[data-servings="${servings}"]`);
    $activeBtn.show().addClass('is_active_hero');

    $('#' + $checked.val() + '_price').show();
    $('#' + $checked.val() + '_cup').show();
  }

  updateHeroPrice();
  $('.hero_input_list input[type="radio"]').on('change', updateHeroPrice);

  const swiper = new Swiper('.alcami-video-swiper', {
    slidesPerView: 6,
    spaceBetween: 20,
    loop: true,
    speed: 14000,
    allowTouchMove: false,
    simulateTouch: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    breakpoints: {
      0: { slidesPerView: 3 },
      769: { slidesPerView: 6 }
    }
  });

  $('.alcami-video-swiper').on('mouseenter', function () {
    isMouseInsideSlider = true;
    swiper.autoplay.stop();
  }).on('mouseleave', function () {
    isMouseInsideSlider = false;
    resumeMarqueeIfAllowed();
  });

  function resumeMarqueeIfAllowed() {
    if (!isMouseInsideSlider && !currentPlayingVideo) {
      swiper.allowTouchMove = true;
      swiper.autoplay.start();
    }
  }

  $('.tiktok-video-embed .video-play svg, .tiktok-video-embed .video-play svg path').on('click', function () {
    const $videoItem = $(this).closest('.tiktok-video-item');
    const videoEl = $videoItem.find('video')[0];
    const $poster = $videoItem.find('.video-poster');

    if (currentPlayingVideo && currentPlayingVideo !== videoEl) {
      const $oldItem = $(currentPlayingVideo).closest('.tiktok-video-item');
      $oldItem.find('.video-poster').show();
      currentPlayingVideo.pause();
      $oldItem.addClass('video-hidden play-video-act').removeClass('pause-video-act ended_video');
    }

    swiper.autoplay.stop();
    swiper.allowTouchMove = false;

    if (!$poster.attr('src')) {
      $poster.attr('src', $(videoEl).attr('poster'));
    }

    $poster.hide();
    $videoItem.removeClass('video-hidden');

    if (videoEl.paused) {
      videoEl.play();
      $videoItem.addClass('pause-video-act').removeClass('play-video-act ended_video');
      currentPlayingVideo = videoEl;
    }
  });

  $('.tiktok-video-embed .video-pause svg, .tiktok-video-embed .video-pause svg path').on('click', function () {
    const $videoItem = $(this).closest('.tiktok-video-item');
    const videoEl = $videoItem.find('video')[0];
    const $poster = $videoItem.find('.video-poster');

    if (!videoEl.paused) {
      videoEl.pause();
      $poster.show();
      $videoItem.addClass('video-hidden play-video-act').removeClass('pause-video-act ended_video');
      currentPlayingVideo = null;
    }

    resumeMarqueeIfAllowed();
  });

  $('.tiktok-video-embed video').on('ended', function () {
    const $videoItem = $(this).closest('.tiktok-video-item');
    const $poster = $videoItem.find('.video-poster');
    this.currentTime = 0;
    $poster.show();
    $videoItem.addClass('ended_video video-hidden').removeClass('play-video-act pause-video-act');
    currentPlayingVideo = null;
    resumeMarqueeIfAllowed();
  });

  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('mini-cart-variant-select')) return;
    const select = e.target;
    const variantId = select.value;
    const container = select.closest('li');
    const btn = container.querySelector('.mini-cart-atc');
    if (btn) {
      btn.setAttribute('data-variant-id', variantId);
    }
  });

  $(".cart_drawer_announcements .cart_drawer_announce_list").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    fade: true,
    cssEase: 'linear'
  });

  $(".cart-recommendations-cart-drawer .mini-cart__navigation").slick({
    dots: false,
    arrows: true,
    appendArrows: '.cart-rec-arrows',
    infinite: false,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.cart_drawer_announcements .cart_drawer_announce_list').slick('setPosition');

  // ----------------------------
  // OPEN DRAWER FAST
  // ----------------------------
  function openMiniCart(){
    document.querySelectorAll("details.cart-drawer-container").forEach(drawer=>{
      if(!drawer.hasAttribute("open")){
        drawer.setAttribute("open","");
      }
      drawer.classList.add("menu-opening");
    });
    document.body.classList.add("mini-cart--open");
  }

  async function refreshCartIcon() {
    const html = await fetch(`/cart?section_id=header&_=${Date.now()}`)
      .then(r => r.text());

    const doc = new DOMParser().parseFromString(html, "text/html");

    const newIcon = doc.querySelector("#cart-icon-bubble");
    const oldIcon = document.querySelector("#cart-icon-bubble");

    if (newIcon && oldIcon) {
      oldIcon.replaceWith(newIcon);
    }
  }

  // ----------------------------
  // BACKGROUND CART REFRESH
  // ----------------------------
  async function refreshMiniCart(productId = null){
    try{
      // update cart count
      const cart = await fetch("/cart.js").then(r=>r.json());
      await refreshCartIcon();
      document.querySelectorAll("#cart-icon-bubble .cart-count-bubble").forEach(bubble=>{
        if(cart.item_count > 0){
          bubble.classList.remove("hidden");
          if(cart.item_count >= 100){
            bubble.classList.add("cart-count-bubble--dot");
            bubble.innerHTML = "";
          }else{
            bubble.classList.remove("cart-count-bubble--dot");
            bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
          }
        }else{
          bubble.classList.add("hidden");
          bubble.innerHTML = "";
        }
      });

      // refresh mini cart html
      const html = await fetch(`/cart?section_id=mini-cart&_=${Date.now()}`).then(r=>r.text());
      const doc = new DOMParser().parseFromString(html,"text/html");
      const newCart = doc.querySelector("form.mini-cart");
      if(newCart){
        document.querySelectorAll("details.cart-drawer-container mini-cart").forEach(cartEl=>{
          cartEl.innerHTML = "";
          cartEl.appendChild(newCart.cloneNode(true));
        });
      }

      // Tek Gift app sync (only for add-to-cart)
      if(productId){
        setTimeout(async()=>{
          const giftCart = await fetch("/cart.js")
          .then(r=>r.json());
          if(giftCart.item_count !== cart.item_count){
            refreshMiniCart(productId);
          }
        },1500);
      }

      // recommendations only when product added
      if(productId){
        loadRecommendations(productId);
      }
    }catch(e){
      console.log("refresh cart error", e);
    }
  }

  // ----------------------------
  // LOAD RECOMMENDATIONS LATER
  // ----------------------------
  async function loadRecommendations(productId){
    if(!productId) return;
    const recommendationsEl = document.querySelector("cart-recommendations");
    if(!recommendationsEl) return;
    try{

      const html = await fetch(`/recommendations/products?section_id=mini-cart&limit=4&product_id=${productId}`)
      .then(r=>r.text());

      const doc = new DOMParser().parseFromString(html,"text/html");
      const newRec = doc.querySelector("cart-recommendations");

      if(newRec){
        recommendationsEl.replaceWith(newRec);
      }
    }catch(e){
      console.log(e);
    }
  }

  document.addEventListener("click", async function (e) {
    const el = e.target.closest("#ah-AddToCart a, #kit_hero_try_button, .sticky_btn, .onetp, .subsp, #otp_hero_link, .bought-list li a.bought-product-add, .try-once-btn.is-active, .choose-flavour-btn a");
    if (!el) return;

    const href = el.getAttribute("href");
    if (!href || !href.includes("/cart/add")) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    console.log("Intercepted click");

    const productsPage = el.closest(".products-page");
    const stickybtn = el.closest(".sticky-offer");
    const flvbox = el.closest(".choose-flavour-area");
    document.body.classList.add("updating-cart");

    if (productsPage) productsPage.classList.add("update_cart_row");
    if (stickybtn) stickybtn.classList.add("update_cart_row2");
    if (flvbox) flvbox.classList.add("update_cart_row");

    try {
      const url = new URL(href, window.location.origin);
      const payload = {
        id: url.searchParams.get("id"),
        quantity: url.searchParams.get("quantity") || 1
      };

      const selling_plan = url.searchParams.get("selling_plan");

      if (selling_plan) {
        payload.selling_plan = selling_plan;
      }

      // ----------------------------
      // ADD PRODUCT
      // ----------------------------
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(payload)
      });

      const addData = await addResponse.json();
      openMiniCart();
      refreshMiniCart(addData.product_id);
    } catch(err) {
      console.error("Cart error:", err);
    } finally {
      document.body.classList.remove("updating-cart");
      if(productsPage) productsPage.classList.remove("update_cart_row");
      if(stickybtn) stickybtn.classList.remove("update_cart_row2");
      if(flvbox) flvbox.classList.remove("update_cart_row");
    }
  });

  document.addEventListener("submit", async function (e) {
    const form = e.target.closest("form[action*='/cart/add']");
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    console.log("Intercepted form submit");
    const productsPage = form.closest(".products-page");
    document.body.classList.add("updating-cart");
    if (productsPage) {
      productsPage.classList.add("update_cart_row");
    }
    try {
      const formData = new FormData(form);
      const payload = {
        id: formData.get("id"),
        quantity: formData.get("quantity") || 1
      };
      const selling_plan = formData.get("selling_plan");
      if (selling_plan) {
        payload.selling_plan = selling_plan;
      }
      // -----------------------------
      // ADD PRODUCT
      // -----------------------------
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(payload)
      });
      const addData = await addResponse.json();
      console.log("Product added:", addData);
      openMiniCart();
      refreshMiniCart(addData.product_id);
    } catch(err) {
      console.error("Cart update error:", err);
    } finally {
      document.body.classList.remove("updating-cart");
      if(productsPage) {
        productsPage.classList.remove("update_cart_row");
      }
    }
  });

  document.addEventListener("click", async function (e) {
    const el = e.target.closest("a.delete-product");
    if (!el) return;
    const href = el.getAttribute("href");
    if (!href) return;
    const url = new URL(href, window.location.origin);
    if (!url.pathname.includes("/cart/change")) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    console.log("Remove intercepted");
    try {
      const id = url.searchParams.get("id");
      const quantity = url.searchParams.get("quantity") || 0;
      // Remove item
      const res = await fetch("/cart/change.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({id, quantity})
        }
      );

      const data = await res.json();
      console.log("Item removed:", data);
      openMiniCart();
      refreshMiniCart();
    } catch(err) {
      console.error("Remove error:", err);
    }
  }, true);

  document.addEventListener("change", async function (e) {
    const select = e.target.closest(".mini-cart__navigation .custom-select");
    if (!select) return;

    const li = select.closest("li[data-variant-id]");
    if (!li) return;

    document.body.classList.add("updating-cart");

    try {
      const payload = {
        id: li.dataset.variantId,
        quantity: Number(select.value),
      };

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const cart = await response.json();
      openMiniCart();
      refreshMiniCart();
    } catch (err) {
      console.error("Quantity update error:", err);
    } finally {
      document.body.classList.remove("updating-cart");
    }
  });

  const targetSelector = "#shopify-section-template--21620728398039__177122591210dd36ae";

  function scrollToReviews() {
    const target = document.querySelector(targetSelector);
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

      history.replaceState(null, null, window.location.pathname + window.location.search);
      return true;
    }
    return false;
  }

  const trigger2 = document.querySelector(".redirect-pdp");
  if (trigger2) {
    trigger2.addEventListener("click", function () {
      const pdpLink = this.getAttribute("pdp-link");
      if (pdpLink) {
        window.location.href = pdpLink + "#reviews";
      }
    });
  }

  const trigger = document.querySelector("body.template-product .jdgm-widget.jdgm-preview-badge");
  if (trigger) {
    trigger.addEventListener("click", scrollToReviews);
  }

  if (window.location.hash === "#reviews") {
    if (!scrollToReviews()) {
      let attempts = 0;
      const maxAttempts = 20;

      const interval = setInterval(() => {
        if (scrollToReviews() || attempts > maxAttempts) {
          clearInterval(interval);
        }
        attempts++;
      }, 100);
    }
  }

  setInterval(() => {
    const hasBar = document.querySelector('div.essential_annoucement_bar_wrapper');

    if (hasBar) {
      document.body.classList.add('with_essential_bar');
      document.body.classList.remove('without_essential_bar');
    } else {
      document.body.classList.add('without_essential_bar');
      document.body.classList.remove('with_essential_bar');
    }
  }, 500);

  $(".announce-slick").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 2700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1800
  });

  function toggleHeaderClass() {
    if (document.body.classList.contains('template-page-lp24')) {
      return;
    }
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    if (window.scrollY > 54) {
      document.body.classList.add('header-sticky');
    } else {
      document.body.classList.remove('header-sticky');
    }
  }

  window.addEventListener('load', toggleHeaderClass);
  window.addEventListener('scroll', toggleHeaderClass);

  (function () {
    var rebuyCheck = setInterval(function () {
      if (window.Rebuy && typeof window.Rebuy === 'object') {
        document.body.classList.add('rebuy-loaded');
        clearInterval(rebuyCheck);
      }
    }, 200);
  })();

  $(document).on('click', '.quantity__button', function () {
    if (!$('body').hasClass('template-cart')) return;

    var $button = $(this);
    var $quantityInput = $button.closest('.quantity').find('.quantity__input');
    var currentQty = parseInt($quantityInput.val(), 10);
    var lineIndex = $quantityInput.data('index');

    // Calculate new quantity
    if ($button.attr('name') === 'plus') {
      currentQty = currentQty + 1;
    } else if ($button.attr('name') === 'minus') {
      currentQty = Math.max(0, currentQty - 1);
    }

    $('body').addClass('updating-cart');
    $button.closest(".cart-item").addClass("update_cart_row");
    $quantityInput.val(currentQty);

    if (currentQty === 0) {
      $.getJSON('/cart.js', function(cart) {
        var updates = {};
        updates[lineIndex] = 0;
        cart.items.forEach(function(item, index) {
          if (item.properties && item.properties['_salepify-advanced-fg']) {
            updates[index + 1] = 0;
          }
        });
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {updates: updates},
          dataType: 'json',
          success: function () {
            console.log('Cart and free gift updated');
            location.reload(true);
            $('body').removeClass('updating-cart');
          },
          error: function (error) {
            console.error('Cart update failed:', error);
            $('body').removeClass('updating-cart');
          }
        });
      });
    } else {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          line: lineIndex,
          quantity: currentQty
        },
        dataType: 'json',
        success: function () {
          console.log('Cart updated');
          location.reload(true);
        },
        error: function (error) {
          console.error('Cart update failed:', error);
        }
      });
    }
  });

  const counters = document.querySelectorAll(".clarity_counter_strip li h6");

  function startCounter(counter) {
    let finalValue = parseInt(counter.textContent);
    let currentValue = 0;
    let speed = Math.ceil(finalValue / 50);

    let interval = setInterval(() => {
      currentValue += speed;
      if (currentValue >= finalValue) {
        currentValue = finalValue;
        clearInterval(interval);
      }
      counter.textContent = currentValue + "%";
    }, 50);
  }

  function checkViewport() {
    counters.forEach((counter) => {
      const rect = counter.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom >= 0) {
        if (!counter.classList.contains("animated")) {
          counter.classList.add("animated");
          startCounter(counter);
        }
      }
    });
  }

  window.addEventListener("scroll", checkViewport);
  checkViewport();
});

function initIngredients(section) {
  console.log("initializing....");
  const slider = section.querySelector('.ingredient-slider-ss');

  if (!slider) return;
  if (slider.classList.contains('swiper-initialized')) return;
  slider.classList.remove('preview');

  new Swiper(slider, {
    speed: 300,
    navigation: {
      nextEl: section.querySelector('.swiper-next-ingredient-ss'),
      prevEl: section.querySelector('.swiper-prev-ingredient-ss'),
    },
    scrollbar: {
      el: section.querySelector('.swiper-scroll-ingredient-ss'),
      draggable: true,
    },
    breakpoints: {
      320: {
        spaceBetween: parseInt(slider.dataset.gapMobile || 0),
        slidesPerView: parseFloat(slider.dataset.viewMobile || 1),
      },
      1024: {
        spaceBetween: parseInt(slider.dataset.gap || 0),
        slidesPerView: parseFloat(slider.dataset.view || 1),
      }
    }
  });

}

function loadIngredients() {
  document.querySelectorAll('.ingredients-section').forEach(section => initIngredients(section));
}

document.addEventListener('DOMContentLoaded', loadIngredients);

$(document).ready(function() {
  const tripleComboVariantMap = {
    "subs_to1|subs_to2|subs_to3": "46367316410583",
    "subs_to1|subs_to2|subs_tm3": "46367328174295",
    "subs_to1|subs_to2|subs_tc3": "46367328207063",
    "subs_to1|subs_to2|subs_te3": "47305060122839",

    "subs_to1|subs_tm2|subs_to3": "46367316443351",
    "subs_to1|subs_tm2|subs_tm3": "46367328239831",
    "subs_to1|subs_tm2|subs_tc3": "46367328272599",
    "subs_to1|subs_tm2|subs_te3": "47305060155607",

    "subs_to1|subs_tc2|subs_to3": "46367316476119",
    "subs_to1|subs_tc2|subs_tm3": "46367328305367",
    "subs_to1|subs_tc2|subs_tc3": "46367328338135",
    "subs_to1|subs_tc2|subs_te3": "47305060188375",

    "subs_to1|subs_te2|subs_to3": "47305060221143",
    "subs_to1|subs_te2|subs_tm3": "47305060253911",
    "subs_to1|subs_te2|subs_tc3": "47305060286679",
    "subs_to1|subs_te2|subs_te3": "47305060319447",

    "subs_tm1|subs_to2|subs_to3": "46367316508887",
    "subs_tm1|subs_to2|subs_tm3": "46367328370903",
    "subs_tm1|subs_to2|subs_tc3": "46367328403671",
    "subs_tm1|subs_to2|subs_te3": "47305060352215",

    "subs_tm1|subs_tm2|subs_to3": "46367316541655",
    "subs_tm1|subs_tm2|subs_tm3": "46367328436439",
    "subs_tm1|subs_tm2|subs_tc3": "46367328469207",
    "subs_tm1|subs_tm2|subs_te3": "47305060384983",

    "subs_tm1|subs_tc2|subs_to3": "46367316574423",
    "subs_tm1|subs_tc2|subs_tm3": "46367328501975",
    "subs_tm1|subs_tc2|subs_tc3": "46367328534743",
    "subs_tm1|subs_tc2|subs_te3": "47305060417751",

    "subs_tm1|subs_te2|subs_to3": "47305060450519",
    "subs_tm1|subs_te2|subs_tm3": "47305060483287",
    "subs_tm1|subs_te2|subs_tc3": "47305060516055",
    "subs_tm1|subs_te2|subs_te3": "47305060548823",

    "subs_tc1|subs_to2|subs_to3": "46367316607191",
    "subs_tc1|subs_to2|subs_tm3": "46367328567511",
    "subs_tc1|subs_to2|subs_tc3": "46367328600279",
    "subs_tc1|subs_to2|subs_te3": "47305060581591",

    "subs_tc1|subs_tm2|subs_to3": "46367316639959",
    "subs_tc1|subs_tm2|subs_tm3": "46367328633047",
    "subs_tc1|subs_tm2|subs_tc3": "46367328665815",
    "subs_tc1|subs_tm2|subs_te3": "47305060614359",

    "subs_tc1|subs_tc2|subs_to3": "46367316672727",
    "subs_tc1|subs_tc2|subs_tm3": "46367328698583",
    "subs_tc1|subs_tc2|subs_tc3": "46367328731351",
    "subs_tc1|subs_tc2|subs_te3": "47305060647127",

    "subs_tc1|subs_te2|subs_to3": "47305060679895",
    "subs_tc1|subs_te2|subs_tm3": "47305060712663",
    "subs_tc1|subs_te2|subs_tc3": "47305060745431",
    "subs_tc1|subs_te2|subs_te3": "47305060778199",

    "subs_te1|subs_to2|subs_to3": "47305060810967",
    "subs_te1|subs_to2|subs_tm3": "47305060843735",
    "subs_te1|subs_to2|subs_tc3": "47305060876503",
    "subs_te1|subs_to2|subs_te3": "47305060909271",

    "subs_te1|subs_tm2|subs_to3": "47305060942039",
    "subs_te1|subs_tm2|subs_tm3": "47305060974807",
    "subs_te1|subs_tm2|subs_tc3": "47305061007575",
    "subs_te1|subs_tm2|subs_te3": "47305061040343",

    "subs_te1|subs_tc2|subs_to3": "47305061073111",
    "subs_te1|subs_tc2|subs_tm3": "47305061105879",
    "subs_te1|subs_tc2|subs_tc3": "47305061138647",
    "subs_te1|subs_tc2|subs_te3": "47305061171415",

    "subs_te1|subs_te2|subs_to3": "47305061204183",
    "subs_te1|subs_te2|subs_tm3": "47305061236951",
    "subs_te1|subs_te2|subs_tc3": "47305061269719",
    "subs_te1|subs_te2|subs_te3": "47305061302487"
  };

  const comboVariantMap = {
    "subs_do1|subs_do2": "44546782232791",
    "subs_do1|subs_de2": "47308765561047",
    "subs_do1|subs_dm2": "45035605098711",
    "subs_do1|subs_dc2": "44546823258327",

    "subs_de1|subs_do2": "47308765659351",
    "subs_de1|subs_de2": "47308765757655",
    "subs_de1|subs_dm2": "47308765692119",
    "subs_de1|subs_dc2": "47308765724887",

    "subs_dm1|subs_do2": "45035605131479",
    "subs_dm1|subs_de2": "47308765593815",
    "subs_dm1|subs_dm2": "45035605197015",
    "subs_dm1|subs_dc2": "45035605295319",

    "subs_dc1|subs_do2": "44546782298327",
    "subs_dc1|subs_de2": "47308765626583",
    "subs_dc1|subs_dm2": "45035605393623",
    "subs_dc1|subs_dc2": "44546823389399"
  };

  var firstTab = $('.faq-tabs__nav li.active').data('tab');

  var firstFaq = $('#tab-' + firstTab).find('.acc__card').first();
  if (firstFaq.length) {
    $('.acc__panel').stop(true, true).slideUp();
    $('.acc__card').removeClass('active active_item');
    $('.acc__title').removeClass('active');

    firstFaq.addClass('active');
    firstFaq.find('.acc__panel').stop(true, true).slideDown();
    firstFaq.find(".acc__title").addClass("active");
  }

  $('.faq-tabs__nav li').on('click', function () {
    var tabId = $(this).data('tab');

    $('.faq-tabs__nav li').removeClass('active');
    $(this).addClass('active');

    $('.faq-tab').removeClass('active');
    $('#tab-' + tabId).addClass('active');
    $('.acc__panel').stop(true, true).slideUp();
    $('.acc__card').removeClass('active active_item');
    $('.acc__title').removeClass('active');

    var firstFaq = $('#tab-' + tabId).find('.acc__card').first();

    if (firstFaq.length) {
      firstFaq.addClass('active');
      firstFaq.addClass('active_item');
      firstFaq.find('.acc__panel').stop(true, true).slideDown();
      firstFaq.find(".acc__title").addClass("active");
    }
  });

  $('.tabbed-blog-m').each(function () {
    const $section = $(this);
    $section.find('.tabbed-blog__tab').on('click', function () {
      const tabId = $(this).data('tab');
      $section.find('.tabbed-blog__tab').removeClass('is-active');
      $(this).addClass('is-active');
      $section.find('.tabbed-blog__content').removeClass('is-active');
      $section.find('.tabbed-blog__content[data-content="' + tabId + '"]').addClass('is-active');
    });

  });

  // Affiliate Program FAQs
  $(".alcami-page-v2faq").on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.alcami-page-v2faq');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

  // FAQs
  $('.faqs-list').on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.faqs-list');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

  // PDP Accordions
  $('.elements-triple-v2-home').on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.elements-triple-v2-home');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

  // Default PDP Accordions
  $('.pdp-default-sec').on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.pdp-default-sec');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

    $(".hero_input_flavor_list label.30label").on("click",function(){
      var dataimg = $(this).attr("data-image");
      var index = $('.main-gallery img').toArray().findIndex(function(img) {
        return $(img).attr('src') === dataimg;
      });

      if (index !== -1) {
        $('.main-gallery').slick('slickGoTo', index);
      }

      var datvarID = $(this).attr("data-idd");
      if (!datvarID) return;

      var $btn = $(".try-once-btn.is-active");
      if (!$btn.length) return;

      var $btn2 = $(".single_hero_btn.is_active_hero");
      if (!$btn2.length) return;

      var url = new URL($btn.attr("href"));
      url.searchParams.set("id", datvarID);

      var url2 = new URL($btn2.attr("href"));
      url2.searchParams.set("id", datvarID);
     
      var pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set("variant", datvarID);
      window.history.replaceState({}, "", pageUrl.toString());

      if (!url.searchParams.get("quantity")) {
        url.searchParams.set("quantity", "1");
      }
      if (!url2.searchParams.get("quantity")) {
        url2.searchParams.set("quantity", "1");
      }

      $btn.attr("href", url.toString());
      $btn2.attr("href", url2.toString());
    });

    $(".hero_input_flavor_list label.60label").on("click",function(){
      const flavour1 = $('input[name="subs_double-flavour1"]:checked').val();
      const flavour2 = $('input[name="subs_double-flavour2"]:checked').val();
      var dataimg = $(this).attr("data-image");

      var index = $('.main-gallery img').toArray().findIndex(function(img) {
        return $(img).attr('src') === dataimg;
      });

      if (index !== -1) {
        $('.main-gallery').slick('slickGoTo', index);
      }

      if (!flavour1 || !flavour2) return;
      const comboKey = `${flavour1}|${flavour2}`;
      const variantId = comboVariantMap[comboKey];

      if (!variantId) return;
      const $btn = $(".try-once-btn.is-active");
      const $btn2 = $(".single_hero_btn.is_active_hero");
      
      if ($btn.length) {
        const url = new URL($btn.attr("href"));
        url.searchParams.set("id", variantId);
        url.searchParams.set("quantity", "1");
        $btn.attr("href", url.toString());

        var pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", pageUrl.toString());
      }

      if ($btn2.length) {
        const url2 = new URL($btn2.attr("href"));
        url2.searchParams.set("id", variantId);
        url2.searchParams.set("quantity", "1");
        $btn2.attr("href", url2.toString());
      }
    });

    $(".hero_input_flavor_list label.90label").on("click",function(){
      const flavour1 = $('input[name="subs_triple-flavour1"]:checked').val();
      const flavour2 = $('input[name="subs_triple-flavour2"]:checked').val();
      const flavour3 = $('input[name="subs_triple-flavour3"]:checked').val();
      var dataimg = $(this).attr("data-image");

      var index = $('.main-gallery img').toArray().findIndex(function (img) {
        return $(img).attr('src') === dataimg;
      });

      if (index !== -1) {
        $('.main-gallery').slick('slickGoTo', index);
      }

      if (!flavour1 || !flavour2 || !flavour3) return;
      const comboKey = `${flavour1}|${flavour2}|${flavour3}`;
      const variantId = tripleComboVariantMap[comboKey];

      if (!variantId) return;
      const $btn = $(".try-once-btn.is-active");
      const $btn2 = $(".single_hero_btn.is_active_hero");

      if ($btn.length) {
        const url = new URL($btn.attr("href"));
        url.searchParams.set("id", variantId);
        url.searchParams.set("quantity", "1");
        var pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set("variant", variantId);
        window.history.replaceState({}, "", pageUrl.toString());
        $btn.attr("href", url.toString());
      }

      if ($btn2.length) {
        const url2 = new URL($btn2.attr("href"));
        url2.searchParams.set("id", variantId);
        url2.searchParams.set("quantity", "1");
        $btn2.attr("href", url2.toString());
      }
    });

    let urlParams = new URLSearchParams(window.location.search);
    let variant = urlParams.get('variant');

    if(variant != null){
      console.log("variant: "+variant);

      if(variant == 44546730819799){
        $(".hero_input_flavor_list label").each(function(){
          var ln = $(this).attr("ln");
          
          if (ln == "Cacao") {
            $(this).children("input").prop("checked", true);
            setTimeout(() => {
              $(this).trigger("click");
            }, 300);
          }
        });
      }

      if(variant == 45035602870487){
        $(".hero_input_flavor_list label").each(function(){
          var ln = $(this).attr("ln");
          
          if (ln == "Matcha") {
            $(this).children("input").prop("checked", true);
            setTimeout(() => {
              $(this).trigger("click");
            }, 300);
          }
        });
      }

      if(variant == 47298927263959){
        $(".hero_input_flavor_list label").each(function(){
          var ln = $(this).attr("ln");
          
          if (ln == "Espresso") {
            $(this).children("input").prop("checked", true);
            setTimeout(() => {
              $(this).trigger("click");
            }, 300);
          }
        });
      }
    }

    function animateValue(el, start, end, duration, callback) {
      let startTime = null;

      function step(currentTime) {
          if (!startTime) startTime = currentTime;
          const progress = Math.min((currentTime - startTime) / duration, 1);
          el.textContent = Math.floor(progress * (end - start) + start).toLocaleString() + '%';

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            if (callback) callback();
          }
      }

      requestAnimationFrame(step);
    }

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function startAnimating(num) {
      const target = +num.getAttribute('data-target');
      animateValue(num, 0, target, 5000);
    }

    function startHoverAnimation() {
      const numbers = document.querySelectorAll('.impact-number');
      numbers.forEach(num => {
        num.addEventListener('mouseenter', function() {
          numbers.forEach(t => {
            if (t !== num) {
              const targetValue = t.getAttribute('data-target');
              t.textContent = targetValue.toLocaleString() + '%';
            }
          });
          const targetValue = parseInt(num.getAttribute('data-target'), 10);
          animateValue(num, 0, targetValue, 5000);
        });

        num.addEventListener('mouseleave', function() {
          const targetValue = num.getAttribute('data-target');
          num.textContent = targetValue.toLocaleString() + '%';
        });
      });
    }

    window.onload = startHoverAnimation;

    (function () {
      const searchModal = document.querySelector('.header__right .search-modal');
      if (!searchModal) return;
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;

      searchModal.addEventListener('click', function (event) {
        const overlay = event.target.closest('.modal-overlay');
        if (!overlay) return;
        const details = overlay.closest('details');
        if (details?.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });

      if (isDesktop) return;

      document.addEventListener('touchstart', function (e) {
        const details = searchModal.querySelector('details[open]');
        if (!details) return;
        const input = details.querySelector('.search__input');
        const predictive = details.querySelector('.predictive-search');
        if (input?.contains(e.target) || predictive?.contains(e.target)) {
          return;
        }

        e.preventDefault();
        details.removeAttribute('open');
      },
      { passive: false });
    })();

    $(document).on('click', '.header__right .search-modal button.close-search-modal', function (e) {
      e.preventDefault();
      $(this).closest('.header__right').find('search-modal details[open]').removeAttr('open');
    });

});

(async function () {

  const section3 = document.querySelector(".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver");
  if (!section3) return;

  $('.alcami-leaders-list').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  });

  $('.balanced-day-list').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: "unslick"
      }
    ]
  });

  $('.unique-perks-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-thumbnail-gallery').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      { breakpoint: 767, settings: { slidesToShow: 3 } }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-thumbnail-gallery',
    focusOnSelect: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          adaptiveHeight: true
        }
      }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-thumbnail-gallery').on('click', 'img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery').slick('slickGoTo', index);
  });

  const teaItems = section3.querySelectorAll(".new-layout-tea-item");
  if (!teaItems.length) return;

  const atcBtn3 = section3.querySelector("#kit_hero_try_button");
  const otpBtn3 = section3.querySelector("#otp_hero_link");
  const summaryContainer = section3.querySelector("[data-summary]");

  teaItems.forEach(el => el.classList.remove("active-tea-item"));
  let activeItem = teaItems[0];
  activeItem.classList.add("active-tea-item");

  function setActiveItem(item) {
    teaItems.forEach(el => el.classList.remove("active-tea-item"));
    item.classList.add("active-tea-item");
    activeItem = item;
  }

  function isActive(item) {
    return item.classList.contains("active-tea-item");
  }

  teaItems.forEach(item => {
    const input = item.querySelector(".new-tea-qty");
    if (!input) return;
    
    // Set first item default to 1
    if (item === teaItems[0]) {
      input.value = 1;
      input.dataset.lastValidValue = 1;
    } else {
      input.value = 0;
      input.dataset.lastValidValue = 0;
    }
    updateTeaSummary();
    item.addEventListener("click", function (e) {
      if (
        e.target.classList.contains("plus-tea") ||
        e.target.classList.contains("minus-tea") ||
        e.target.classList.contains("new-tea-qty")
      ) return;
      setActiveItem(this);

      const targetImg = this.dataset.img;
      if (!targetImg) return;
      const $gallery = $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery');
      let slideIndex = -1;

      $gallery.find('.slick-slide').each(function () {
        const imgEl = $(this).find('img').first();
        const imgSrc = imgEl.attr('src');
        if (imgSrc && imgSrc.startsWith(targetImg)) {
          slideIndex = $(this).data('slick-index');
          return false;
        }
      });

      if (slideIndex >= 0) {
        $gallery.slick('slickGoTo', slideIndex);
      }

    });
  });

  function updateTeaSummary() {
    const selectionBox = section3.querySelector(".new-tea-your-selection");
    const selectedItemsEl = section3.querySelector(".new-tea-selected-items");
    const totalEl = section3.querySelector(".new-tea-total-value");
    if (!summaryContainer || !selectionBox) return;

    const items = section3.querySelectorAll(".new-layout-tea-item");
    const data = [];
    let total = 0;

    items.forEach(item => {
      const qtyInput = item.querySelector(".new-tea-qty");
      const idInput = item.querySelector(".new-tea-pdp-id");
      const subInput = item.querySelector(".new-tea-subscription");
      const title = item.querySelector("h3")?.innerText || "";
      const qty = parseInt(qtyInput.value || 0);
      const id = idInput?.value;

      if (qty > 0) {
        let price = 0;
        if (subInput?.dataset.subscriptionPrice) {
          const rawPrice = subInput.dataset.subscriptionPrice;
          const cents = parseInt(rawPrice.replace(/[^\d]/g, ""), 10) || 0;
          price = cents / 100;
        }
        const itemTotal = price * qty;
        total += itemTotal;

        data.push({id, qty, title, price, itemTotal,
          selling_plan_id: subInput?.dataset.sellingPlanId || null,
          subscription_interval: subInput?.dataset.subscriptionInterval || null
        });
      }
    });

    summaryContainer.dataset.summary = JSON.stringify(data);
    summaryContainer._summary = data;
    const hasDecimals = total % 1 !== 0;
    const formattedTotal = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: Shopify.currency.active,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    }).format(total);

    if (data.length > 0) {
      atcBtn3?.classList.remove("disabled");
      otpBtn3?.classList.remove("disabled");
      if (atcBtn3) atcBtn3.textContent = `Start Ritual • ${formattedTotal}`;
    } else {
      atcBtn3?.classList.add("disabled");
      otpBtn3?.classList.add("disabled");
      if (atcBtn3) atcBtn3.textContent = "Start Ritual";
    }

    if (data.length > 0) {
      selectionBox.style.display = "block";
      selectedItemsEl.innerHTML = data.map(item => `
        <div class="selected-row">
          <span>${item.qty} × ${item.title}</span>
        </div>
      `).join("");
      totalEl.textContent = formattedTotal;
    } else {
      selectionBox.style.display = "none";
      selectedItemsEl.innerHTML = "";
      totalEl.textContent = "";
    }
  }

  section3.querySelectorAll(".plus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = parseInt(input.value || 0) + 1;
      input.dataset.lastValidValue = input.value;
      updateTeaSummary();
    });
  });

  section3.querySelectorAll(".minus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = Math.max(0, parseInt(input.value || 0) - 1);
      input.dataset.lastValidValue = input.value;
      updateTeaSummary();
    });
  });

  section3.querySelectorAll(".new-tea-qty").forEach(input => {
    input.dataset.lastValidValue = input.value || 0;
    input.addEventListener("input", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive(item)) {
        this.value = this.dataset.lastValidValue || this.value;
        return;
      }
      if (this.value === "" || parseInt(this.value) < 0) this.value = 0;
      this.dataset.lastValidValue = this.value;
      updateTeaSummary();
    });
  });

  // async function addToCart(isSubscription = false) {
  //   if (!summaryContainer?._summary || summaryContainer._summary.length === 0) return;

  //   const items = summaryContainer._summary.map(item => {
  //     const payload = {
  //       id: Number(item.id),
  //       quantity: Number(item.qty)
  //     };
  //     if (isSubscription && item.selling_plan_id) {
  //       payload.selling_plan = Number(item.selling_plan_id);
  //     }
  //     return payload;
  //   });

  //   if (!items.length) return;

  //   const btn = isSubscription ? atcBtn3 : otpBtn3;
  //   btn?.classList.add("loading");
  //   document.body.classList.add("updating-cart");
  //   section3.querySelector(".alcami-kit-v3-inn")?.classList.add("update_cart_row");

  //   try {
  //     const addResponse = await fetch("/cart/add.js", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json", Accept: "application/json" },
  //       body: JSON.stringify({ items })
  //     });

  //     if (!addResponse.ok) throw new Error("Failed to add items");
  //     const addData = await addResponse.json();
  //     console.log("Added to cart:", addData);

  //     const ts = Date.now();
  //     const cart = await fetch("/cart.js").then(res => res.json());
  //     const bubbles = document.querySelectorAll("#cart-icon-bubble .cart-count-bubble");

  //     bubbles.forEach(bubble => {
  //       if (cart.item_count > 0) {
  //         bubble.classList.remove("hidden");
  //         if (cart.item_count >= 100) {
  //           bubble.classList.add("cart-count-bubble--dot");
  //           bubble.innerHTML = "";
  //         } else {
  //           bubble.classList.remove("cart-count-bubble--dot");
  //           bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
  //         }
  //       } else {
  //         bubble.classList.add("hidden");
  //         bubble.innerHTML = "";
  //       }
  //     });

  //     const miniCartHTMLText = await fetch(`/cart?section_id=mini-cart&_=${ts}`).then(res => res.text());
  //     const parser = new DOMParser();
  //     const miniCartHTML = parser.parseFromString(miniCartHTMLText, "text/html");
  //     const miniCartForm = miniCartHTML.querySelector("form.mini-cart");

  //     if (miniCartForm) {
  //       document.querySelectorAll("details.cart-drawer-container mini-cart").forEach(drawerMiniCart => {
  //         drawerMiniCart.innerHTML = "";
  //         drawerMiniCart.appendChild(miniCartForm.cloneNode(true));
  //       });

  //       setTimeout(() => {
  //         const $announceList = $(".cart_drawer_announcements .cart_draw_announce_list");

  //         if ($announceList.hasClass("slick-initialized")) {
  //           $announceList.slick("refresh");
  //         } else {
  //           $announceList.slick({
  //             dots: false,
  //             arrows: false,
  //             infinite: true,
  //             speed: 700,
  //             slidesToShow: 1,
  //             slidesToScroll: 1,
  //             autoplay: true,
  //             autoplaySpeed: 1000,
  //             fade: true,
  //             cssEase: 'linear'
  //           });
  //         }
  //       }, 100);
  //     }

  //     document.querySelectorAll("details.cart-drawer-container").forEach(drawer => {
  //       drawer.setAttribute("open", "");
  //       drawer.classList.add("menu-opening");
  //     });

  //   } catch (err) {
  //     console.error("Cart update error:", err);
  //   } finally {
  //     btn?.classList.remove("loading");
  //     document.body.classList.remove("updating-cart");
  //     section3.querySelector(".alcami-kit-v3-inn")?.classList.remove("update_cart_row");
  //   }
  // }

  // atcBtn3?.addEventListener("click", e => {
  //   e.preventDefault();
  //   addToCart(true);
  // });

  // otpBtn3?.addEventListener("click", e => {
  //   e.preventDefault();
  //   addToCart(false);
  // });

  async function addToCart(isSubscription = false) {
    if (!summaryContainer?._summary?.length) return;

    const items = summaryContainer._summary.map(item => ({
      id: Number(item.id),
      quantity: Number(item.qty),
      ...(isSubscription && item.selling_plan_id && {
        selling_plan: Number(item.selling_plan_id)
      })
    }));

    if (!items.length) return;

    const btn = isSubscription ? atcBtn3 : otpBtn3;

    btn?.classList.add("loading");
    document.body.classList.add("updating-cart");
    section3.querySelector(".alcami-kit-v3-inn")?.classList.add("update_cart_row");

    try {
      // Add items
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error("Failed to add items");

      // 🚀 Open drawer immediately
      document.querySelectorAll("details.cart-drawer-container").forEach(drawer => {
        drawer.setAttribute("open", "");
        drawer.classList.add("menu-opening");
      });

      // Refresh cart in background
      (async () => {
        try {
          const ts = Date.now();

          const [cart, miniCartHTMLText] = await Promise.all([
            fetch("/cart.js").then(r => r.json()),
            fetch(`/cart?section_id=mini-cart&_=${ts}`).then(r => r.text())
          ]);

          // Update cart bubble
          document.querySelectorAll("#cart-icon-bubble .cart-count-bubble").forEach(bubble => {
            if (cart.item_count > 0) {
              bubble.classList.remove("hidden");

              if (cart.item_count >= 100) {
                bubble.classList.add("cart-count-bubble--dot");
                bubble.innerHTML = "";
              } else {
                bubble.classList.remove("cart-count-bubble--dot");
                bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
              }
            } else {
              bubble.classList.add("hidden");
              bubble.innerHTML = "";
            }
          });

          // Replace mini cart
          const parser = new DOMParser();
          const doc = parser.parseFromString(miniCartHTMLText, "text/html");
          const miniCart = doc.querySelector("form.mini-cart");

          if (miniCart) {
            document
              .querySelectorAll("details.cart-drawer-container mini-cart")
              .forEach(el => {
                el.replaceChildren(miniCart.cloneNode(true));
              });
          }

          // Refresh slick only if needed
          const $list = $(".cart_drawer_announcements .cart_draw_announce_list");

          if ($list.length) {
            if ($list.hasClass("slick-initialized")) {
              $list.slick("refresh");
            } else {
              $list.slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 700,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 1000,
                fade: true,
                cssEase: "linear"
              });
            }
          }
        } catch (err) {
          console.error("Mini cart refresh error:", err);
        }
      })();

    } catch (err) {
      console.error("Cart update error:", err);
    } finally {
      btn?.classList.remove("loading");
      document.body.classList.remove("updating-cart");
      section3.querySelector(".alcami-kit-v3-inn")?.classList.remove("update_cart_row");
    }
  }

  atcBtn3?.addEventListener("click", e => {
    e.preventDefault();
    addToCart(true);
  });

  otpBtn3?.addEventListener("click", e => {
    e.preventDefault();
    addToCart(false);
  });


})();

(async function () {

  const section4 = document.querySelector(".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver");
  if (!section4) return;

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-thumbnail-gallery').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      { breakpoint: 767, settings: { slidesToShow: 3 } }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-thumbnail-gallery',
    focusOnSelect: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
          adaptiveHeight: true
        }
      }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-thumbnail-gallery').on('click', 'img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery').slick('slickGoTo', index);
  });

  const teaItems2 = section4.querySelectorAll(".new-layout-tea-item");
  if (!teaItems2.length) return;

  const atcBtn4 = section4.querySelector("#kit_hero_try_button");
  const otpBtn4 = section4.querySelector("#otp_hero_link");
  const summaryContainer2 = section4.querySelector("[data-summary]");

  teaItems2.forEach(el => el.classList.remove("active-tea-item"));
  let activeItem2 = teaItems2[0];
  activeItem2.classList.add("active-tea-item");

  function setActiveItem2(item) {
    teaItems2.forEach(el => el.classList.remove("active-tea-item"));
    item.classList.add("active-tea-item");
    activeItem2 = item;
  }

  function isActive2(item) {
    return item.classList.contains("active-tea-item");
  }

  teaItems2.forEach(item => {
    const input = item.querySelector(".new-tea-qty");
    if (!input) return;
    
    // Set first item default to 1
    if (item === teaItems2[0]) {
      input.value = 1;
      input.dataset.lastValidValue = 1;
    } else {
      input.value = 0;
      input.dataset.lastValidValue = 0;
    }
    updateTeaSummary2();
    item.addEventListener("click", function (e) {
      if (
        e.target.classList.contains("plus-tea") ||
        e.target.classList.contains("minus-tea") ||
        e.target.classList.contains("new-tea-qty")
      ) return;
      setActiveItem2(this);

      const targetImg = this.dataset.img;
      if (!targetImg) return;
      const $gallery = $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery');
      let slideIndex = -1;

      $gallery.find('.slick-slide:not(.slick-cloned)').each(function () {
        const imgSrc = $(this).find('img').attr('src');

        if (imgSrc && imgSrc.indexOf(targetImg) === 0) {
          slideIndex = Number($(this).attr('data-slick-index'));
          return false;
        }
      });

      if (slideIndex >= 0) {
        $gallery.slick('slickGoTo', slideIndex);
      }
    });
  });

  function updateTeaSummary2() {
    const selectionBox2 = section4.querySelector(".new-tea-your-selection");
    const selectedItemsEl2 = section4.querySelector(".new-tea-selected-items");
    const totalEl2 = section4.querySelector(".new-tea-total-value");

    if (!summaryContainer2 || !selectionBox2) return;

    const items2 = section4.querySelectorAll(".new-layout-tea-item");
    const data2 = [];
    let total2 = 0;

    items2.forEach(item => {
      const qtyInput = item.querySelector(".new-tea-qty");
      const idInput = item.querySelector(".new-tea-pdp-id");
      const subInput = item.querySelector(".new-tea-subscription");
      const title = item.querySelector("h3")?.innerText || "";
      const qty = parseInt(qtyInput.value || 0);
      const id = idInput?.value;

      if (qty > 0) {
        let price = 0;

        if (subInput?.dataset.subscriptionPrice) {
          const rawPrice = subInput.dataset.subscriptionPrice;
          const cents = parseInt(rawPrice.replace(/[^\d]/g, ""), 10) || 0;
          price = cents / 100;
        }

        const itemTotal = price * qty;
        total2 += itemTotal;

        data2.push({id, qty, title, price, itemTotal,
          selling_plan_id: subInput?.dataset.sellingPlanId || null,
          subscription_interval: subInput?.dataset.subscriptionInterval || null
        });
      }
    });

    summaryContainer2.dataset.summary = JSON.stringify(data2);
    summaryContainer2._summary = data2;
    const hasDecimals2 = total2 % 1 !== 0;
    const formattedTotal = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: Shopify.currency.active,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: hasDecimals2 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(total2);

    if (data2.length > 0) {
      atcBtn4?.classList.remove("disabled");
      otpBtn4?.classList.remove("disabled");
      if (atcBtn4) atcBtn4.textContent = `Start Ritual • ${formattedTotal}`;
    } else {
      atcBtn4?.classList.add("disabled");
      otpBtn4?.classList.add("disabled");
      if (atcBtn4) atcBtn4.textContent = "Start Ritual";
    }

    if (data2.length > 0) {
      selectionBox2.style.display = "block";
      selectedItemsEl2.innerHTML = data2.map(item => `
        <div class="selected-row">
          <span>${item.qty} × ${item.title}</span>
        </div>
      `).join("");
      totalEl2.textContent = formattedTotal;
    } else {
      selectionBox2.style.display = "none";
      selectedItemsEl2.innerHTML = "";
      totalEl2.textContent = "";
    }
  }

  section4.querySelectorAll(".plus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive2(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = parseInt(input.value || 0) + 1;
      input.dataset.lastValidValue = input.value;
      updateTeaSummary2();
    });
  });

  section4.querySelectorAll(".minus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive2(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = Math.max(0, parseInt(input.value || 0) - 1);
      input.dataset.lastValidValue = input.value;
      updateTeaSummary2();
    });
  });

  section4.querySelectorAll(".new-tea-qty").forEach(input => {
    input.dataset.lastValidValue = input.value || 0;
    input.addEventListener("input", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive2(item)) {
        this.value = this.dataset.lastValidValue || this.value;
        return;
      }
      if (this.value === "" || parseInt(this.value) < 0) this.value = 0;
      this.dataset.lastValidValue = this.value;
      updateTeaSummary2();
    });
  });

  // async function addToCart2(isSubscription = false) {
  //   if (!summaryContainer2?._summary || summaryContainer2._summary.length === 0) return;

  //   const items = summaryContainer2._summary.map(item => {
  //     const payload = {
  //       id: Number(item.id),
  //       quantity: Number(item.qty)
  //     };
  //     if (isSubscription && item.selling_plan_id) {
  //       payload.selling_plan = Number(item.selling_plan_id);
  //     }
  //     return payload;
  //   });

  //   if (!items.length) return;

  //   const btn = isSubscription ? atcBtn4 : otpBtn4;
  //   btn?.classList.add("loading");
  //   document.body.classList.add("updating-cart");
  //   section4.querySelector(".alcami-kit-v3-inn")?.classList.add("update_cart_row");

  //   try {
  //     const addResponse = await fetch("/cart/add.js", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json", Accept: "application/json" },
  //       body: JSON.stringify({ items })
  //     });

  //     if (!addResponse.ok) throw new Error("Failed to add items");
  //     const addData = await addResponse.json();
  //     console.log("Added to cart:", addData);

  //     const ts = Date.now();
  //     const cart = await fetch("/cart.js").then(res => res.json());
  //     const bubbles = document.querySelectorAll("#cart-icon-bubble .cart-count-bubble");

  //     bubbles.forEach(bubble => {
  //       if (cart.item_count > 0) {
  //         bubble.classList.remove("hidden");
  //         if (cart.item_count >= 100) {
  //           bubble.classList.add("cart-count-bubble--dot");
  //           bubble.innerHTML = "";
  //         } else {
  //           bubble.classList.remove("cart-count-bubble--dot");
  //           bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
  //         }
  //       } else {
  //         bubble.classList.add("hidden");
  //         bubble.innerHTML = "";
  //       }
  //     });

  //     const miniCartHTMLText = await fetch(`/cart?section_id=mini-cart&_=${ts}`).then(res => res.text());
  //     const parser = new DOMParser();
  //     const miniCartHTML = parser.parseFromString(miniCartHTMLText, "text/html");
  //     const miniCartForm = miniCartHTML.querySelector("form.mini-cart");

  //     if (miniCartForm) {
  //       document.querySelectorAll("details.cart-drawer-container mini-cart").forEach(drawerMiniCart => {
  //         drawerMiniCart.innerHTML = "";
  //         drawerMiniCart.appendChild(miniCartForm.cloneNode(true));
  //       });

  //       setTimeout(() => {
  //         const $announceList = $(".cart_drawer_announcements .cart_draw_announce_list");

  //         if ($announceList.hasClass("slick-initialized")) {
  //           $announceList.slick("refresh");
  //         } else {
  //           $announceList.slick({
  //             dots: false,
  //             arrows: false,
  //             infinite: true,
  //             speed: 700,
  //             slidesToShow: 1,
  //             slidesToScroll: 1,
  //             autoplay: true,
  //             autoplaySpeed: 1000,
  //             fade: true,
  //             cssEase: 'linear'
  //           });
  //         }
  //       }, 100);
  //     }

  //     document.querySelectorAll("details.cart-drawer-container").forEach(drawer => {
  //       drawer.setAttribute("open", "");
  //       drawer.classList.add("menu-opening");
  //     });

  //   } catch (err) {
  //     console.error("Cart update error:", err);
  //   } finally {
  //     btn?.classList.remove("loading");
  //     document.body.classList.remove("updating-cart");
  //     section4.querySelector(".alcami-kit-v3-inn")?.classList.remove("update_cart_row");
  //   }
  // }

  // atcBtn4?.addEventListener("click", e => {
  //   e.preventDefault();
  //   addToCart2(true);
  // });

  // otpBtn4?.addEventListener("click", e => {
  //   e.preventDefault();
  //   addToCart2(false);
  // });

  async function addToCart2(isSubscription = false) {
    if (!summaryContainer2?._summary?.length) return;

    const items = summaryContainer2._summary.map(item => ({
      id: Number(item.id),
      quantity: Number(item.qty),
      ...(isSubscription && item.selling_plan_id && {
        selling_plan: Number(item.selling_plan_id)
      })
    }));

    if (!items.length) return;

    const btn = isSubscription ? atcBtn4 : otpBtn4;

    btn?.classList.add("loading");
    document.body.classList.add("updating-cart");
    section4.querySelector(".alcami-kit-v3-inn")?.classList.add("update_cart_row");

    try {
      // Add items
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error("Failed to add items");

      // 🚀 Open drawer immediately
      document.querySelectorAll("details.cart-drawer-container").forEach(drawer => {
        drawer.setAttribute("open", "");
        drawer.classList.add("menu-opening");
      });

      // Refresh cart in the background
      (async () => {
        try {
          const ts = Date.now();

          const [cart, miniCartHTMLText] = await Promise.all([
            fetch("/cart.js").then(r => r.json()),
            fetch(`/cart?section_id=mini-cart&_=${ts}`).then(r => r.text())
          ]);

          // Update cart bubble
          document.querySelectorAll("#cart-icon-bubble .cart-count-bubble").forEach(bubble => {
            if (cart.item_count > 0) {
              bubble.classList.remove("hidden");

              if (cart.item_count >= 100) {
                bubble.classList.add("cart-count-bubble--dot");
                bubble.innerHTML = "";
              } else {
                bubble.classList.remove("cart-count-bubble--dot");
                bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
              }
            } else {
              bubble.classList.add("hidden");
              bubble.innerHTML = "";
            }
          });

          // Update mini cart
          const parser = new DOMParser();
          const doc = parser.parseFromString(miniCartHTMLText, "text/html");
          const miniCart = doc.querySelector("form.mini-cart");

          if (miniCart) {
            document
              .querySelectorAll("details.cart-drawer-container mini-cart")
              .forEach(el => {
                el.replaceChildren(miniCart.cloneNode(true));
              });
          }

          // Refresh Slick
          const $announceList = $(".cart_drawer_announcements .cart_draw_announce_list");

          if ($announceList.length) {
            if ($announceList.hasClass("slick-initialized")) {
              $announceList.slick("refresh");
            } else {
              $announceList.slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 700,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 1000,
                fade: true,
                cssEase: "linear"
              });
            }
          }
        } catch (err) {
          console.error("Mini cart refresh error:", err);
        }
      })();

    } catch (err) {
      console.error("Cart update error:", err);
    } finally {
      btn?.classList.remove("loading");
      document.body.classList.remove("updating-cart");
      section4.querySelector(".alcami-kit-v3-inn")?.classList.remove("update_cart_row");
    }
  }

  atcBtn4?.addEventListener("click", e => {
    e.preventDefault();
    addToCart2(true);
  });

  otpBtn4?.addEventListener("click", e => {
    e.preventDefault();
    addToCart2(false);
  });

})();